// ** Third Party Components
import classnames from 'classnames'
import Chart from 'react-apexcharts'
import { Card, CardBody } from 'reactstrap'

const StatisticsCards = props => {
  // ** Props
  const { className, hideChart, iconRight, iconBg, icon, stat, statTitle, options, series, type, height, colored, disabled } = props

  return (
    <Card className={`${colored && !disabled && 'bg-primary'}`}>
      <CardBody
        className={classnames('d-flex stats-card-body d-flex pt-2', {
          [className]: className,
          'flex-column align-items-start': !iconRight && !hideChart,
          'justify-content-between flex-row-reverse align-items-center': iconRight,
          'justify-content-center flex-column text-center': hideChart && !iconRight,
          'pb-0': !hideChart,
          'pb-2': hideChart
        })}
      >
        <div className='icon-section'>
           {
             !colored &&
             <div className={`avatar avatar-stats p-50 m-0
              ${iconBg
                ? `bg-light-${iconBg}`
                : 'bg-light-primary'}
            `}>
              <div className='avatar-content'>{icon}</div>
            </div>
           }
        </div>
        <div className='title-section'>
          <h2 className={`font-weight-bold mt-1 mb-25 ${
            colored
            &&
            (
              disabled
                ? 'text-muted'
                : 'text-light'
            )
          }`}>
            {
              stat 
                ? (stat.length >= 18
                    ? `${stat.substr(0, 18)}...`
                    : stat
                  )
                : ''
            }
          </h2>
          <p className={`mb-0 ${
            colored
            &&
            (
              disabled
                ? 'text-muted'
                : 'text-light'
            )
          }`}>{statTitle}</p>
        </div>
      </CardBody>
      {!hideChart && <Chart options={options} series={series} type={type} height={height ? height : 100} />}
    </Card>
  )
}
export default StatisticsCards
